import React from 'react';

// A clickable table header that toggles ascending/descending sort on its column.
const SortableHeader = ({ label, sortKey, sortConfig, onSort, className }) => {
  const active = sortConfig?.key === sortKey;
  const icon = !active
    ? 'bi-arrow-down-up'
    : sortConfig.direction === 'asc'
    ? 'bi-caret-up-fill'
    : 'bi-caret-down-fill';
  return (
    <th className={className} scope="col" style={{ whiteSpace: 'nowrap' }}>
      <button
        type="button"
        className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center"
        style={{ cursor: 'pointer', userSelect: 'none' }}
        onClick={() => onSort(sortKey)}
      >
        {label}
        <i
          aria-hidden="true"
          className={`bi ${icon} ms-1 ${active ? 'text-primary' : 'text-muted'}`}
          style={{ fontSize: '0.72rem' }}
        ></i>
      </button>
    </th>
  );
};

export default SortableHeader;
